export enum VoiceProvider {
  OPEN_AI = 'openai',
  ELEVEN_LABS = 'elevenlabs',
}

export interface VoiceOption {
  providerVoiceId: string
  provider: VoiceProvider
  name: string
  gender?: string
  language?: string
  accent?: string
  description?: string
}
